export const translations = {
  it: {
    brand: "DAVIDE CAMPAGNA",
    badge: "ON SET · STAGE 7",
    nav: {
      studio: "Studio 3D",
      filmografia: "Filmografia",
      regia: "Regia",
      attrezzatura: "Attrezzatura",
      costumi: "Costumi",
      stunt: "Stunt",
      galleria: "Galleria",
      produzioni: "Produzioni",
      chisono: "Chi Sono",
      proiezione: "Proiezioni",
      contatti: "Contatti",
    },
    hero: {
      kicker: "Attore · Regista · Stunt Performer",
      line1: "BENVENUTO NEL",
      line2: "MIO SET",
      sub: "Usa il mouse per muoverti tra la troupe, scopri gli hotspot e scegli dove andare.",
      cta: "Entra nello studio",
      modeWalk: "Esplora a piedi",
      modeOrbit: "Vista gru",
      hintWalk: "Trascina per guardarti intorno · clicca sul pavimento per camminare lì · WASD disponibile",
      hintOrbit: "Trascina per ruotare · Scroll per lo zoom",
      warp: "Salto rapido",
      legend: "Avvicinati agli hotspot per scoprire le sezioni",
      hintPoint: "Trascina il cursore per guardarti intorno · clicca i segnali per muoverti",
      map: "Mappa del set",
    },
    cinema: { watch: "Guarda l'estratto" },
    nodes: {
      ingresso: "Ingresso dello studio",
      gru: "Gru e cinepresa",
      cowboy: "Il set western",
      village: "Video village",
      costumi: "Sartoria",
      fotografo: "Fotografo di scena",
      stunt: "Zona stunt",
      bacheca: "Bacheca stampa",
      corridoio: "Corridoio produzione",
      cinema: "Sala cinema",
    },
    hotspots: {
      equipment: "Noleggio attrezzatura",
      actors: "Filmografia da attore",
      director: "Regista",
      costumes: "Noleggio costumi",
      gallery: "Galleria",
      stunt: "Stunt",
      production: "Produzione",
      about: "Chi sono",
      cinema: "Organizza la tua proiezione",
      contacts: "Contatti",
    },
    marquee: "ATTOREREGISTASTUNTPERFORMER",
    films: {
      title: "Filmografia",
      sub: "Ogni titolo della carriera di Davide Campagna, direttamente da IMDb.",
      roleAll: "Tutti i ruoli",
      attore: "Attore",
      regista: "Regista",
      doppiatore: "Doppiatore",
      stunt: "Stunt",
      sceneggiatore: "Sceneggiatore",
      formatAll: "Tutti i formati",
      feature: "Lungometraggi",
      short: "Cortometraggi",
      tv: "Serie & Video",
      details: "Scheda film",
      role: "Ruolo",
      year: "Anno",
      imdbLink: "Apri su IMDb",
      empty: "Nessun titolo con questi filtri.",
      rating: "Valutazione IMDb",
    },
    rental: {
      titleEquip: "Noleggio attrezzatura",
      titleCost: "Noleggio costumi",
      subEquip: "Camere, ottiche, grip e luci di livello cinematografico, pronte per il tuo set.",
      subCost: "",
      perDay: "/giorno",
      costumesText: "Disponiamo di una grande quantità di costumi e oggetti di scena di tutti i tipi che mettiamo a disposizione per il noleggio. Compila il form e facci sapere cosa ti serve, sicuramente ce lo abbiamo!",
      proGear: "Disponiamo anche di macchine da presa e lenti professionali. Compila il form nei contatti per saperne di più.",
      deposit: "Sulla base dell'attrezzatura scelta verrà richiesta una cauzione proporzionata, che verrà poi restituita al termine del noleggio. Su richiesta possiamo occuparci anche del noleggio di costumi scenici e di scenografie.",
      cats: { camere: "Cineprese", ottiche: "Ottiche", grip: "Grip & Movimento", video: "Monitor & Video", luci: "Luci & Pannelli", audio: "Audio", energia: "Energia", set: "Effetti & Set" },
      allCats: "Tutto",
    },
    quote: {
      title: "Il tuo preventivo",
      empty: "Nessun articolo. Aggiungi attrezzatura o costumi dal catalogo.",
      name: "Nome e cognome",
      email: "Email",
      company: "Produzione / Società",
      from: "Dal",
      to: "Al",
      notes: "Note",
      submit: "Invia richiesta preventivo",
      success: "Richiesta inviata! Ti risponderemo entro 24 ore.",
    },
    request: {
      kicker: "RICHIESTA DI PREVENTIVO",
      detail: "Di cosa hai bisogno?",
      placeholder: "Elenca l'attrezzatura, i costumi o gli oggetti di scena che ti servono, le date e il tipo di produzione.",
      submit: "Invia richiesta",
    },
    stunt: {
      title: "Stunt & Performance fisica",
      sub: "Dall'Accademia Internazionale del Circo di Verona ai set internazionali: il corpo come strumento narrativo.",
      skills: ["Cadute da grande altezza", "Full body burn", "Funambolismo & wirework", "Combattimento scenico", "Acrobatica", "Circo"],
      certs: "Formazione: 6 anni all'Accademia Internazionale del Circo di Verona (diploma 2013) · 9 anni di danza classica · Italia's Got Talent 2012 · Performance per Papa Benedetto XVI",
      credits: "Crediti stunt selezionati",
    },
    gallery: {
      title: "Galleria",
      sub: "Set, backstage e azione: la macchina da presa dall'altra parte.",
      empty: "La galleria è in allestimento. Le fotografie ufficiali saranno pubblicate a breve.",
    },
    productions: {
      title: "Produzione",
      sub: "Dallo sviluppo alla distribuzione, con la casa di produzione The Palma Movie.",
      partner: "Da diversi anni Davide Campagna collabora ormai con la casa di produzione The Palma Movie, per scoprire tutte le produzioni visita www.thepalmamovie.com",
      visit: "Visita thepalmamovie.com",
      pitch: "Insieme alla The Palma Movie possiamo valutare il tuo progetto, e farti un preventivo personalizzato per crearti un film dalla A alla Z. Creiamo il film lasciandoti tutti i diritti, dall'ideazione, la scrittura, la pre-produzione, la produzione, la post-produzione, la distribuzione al cinema e in piattaforma e la pubblicità.",
      titles: "Film e serie prodotti",
      titlesSub: "Una selezione delle produzioni The Palma Movie. Clicca per aprire la scheda sul loro sito.",
      openSheet: "Apri la scheda",
    },
    about: {
      title: "Chi sono",
      sub: "Dal circo al cinema: la storia di Davide Campagna.",
      press: "Rassegna stampa",
      pressSub: "Articoli e interviste su Davide Campagna.",
      readArticle: "Leggi l'articolo",
      facts: ["NATO · 11.10.1996 · SCAFATI (SA)", "RESIDENTE IN ALTO ADIGE", "ACCADEMIA D'ARTE CIRCENSE · VERONA · 2013", "CIRKO VERTIGO · TORINO", "STUDIO EMME ACADEMY · RECITAZIONE CINEMATOGRAFICA"],
    },
    screening: {
      title: "Organizza la tua proiezione",
      sub: "Porta un film di Davide Campagna nel tuo cinema, festival o circolo culturale.",
      trailerCta: "Guarda il trailer di",
      cinemaNote: "Vuoi proiettare uno dei nostri film? Contattaci a",
    },
    contact: {
      name: "Nome e cognome",
      email: "Email",
      message: "Messaggio",
      attach: "Allegato (facoltativo)",
      attachCta: "Allega un file",
      attachHint: "PDF o immagine · massimo 8 MB",
      submit: "Invia messaggio",
      sendingLabel: "Invio in corso...",
      success: "Messaggio inviato! Ti rispondo al più presto.",
      error: "Invio non riuscito, riprova.",
      tooBig: "File troppo grande: massimo 8 MB.",
    },
    footer: {
      tagline: "Attore · Regista · Stunt Performer",
      rights: "Tutti i diritti riservati.",
      nav: "Sezioni",
      contact: "Contatti",
      contactCta: "Scrivici dalla pagina Contatti →",
    },
    lang: "EN",
  },
  en: {
    brand: "DAVIDE CAMPAGNA",
    badge: "ON SET · STAGE 7",
    nav: {
      studio: "3D Studio",
      filmografia: "Filmography",
      regia: "Director",
      attrezzatura: "Equipment",
      costumi: "Costumes",
      stunt: "Stunts",
      galleria: "Gallery",
      produzioni: "Productions",
      chisono: "About",
      proiezione: "Screenings",
      contatti: "Contact",
    },
    hero: {
      kicker: "Actor · Director · Stunt Performer",
      line1: "WELCOME TO",
      line2: "MY SET",
      sub: "Use your mouse to move among the crew, discover the hotspots and choose where to go.",
      cta: "Enter the studio",
      modeWalk: "Walk & explore",
      modeOrbit: "Crane view",
      hintWalk: "Drag to look around · click the floor to walk there · WASD works too",
      hintOrbit: "Drag to rotate · Scroll to zoom",
      warp: "Quick warp",
      legend: "Get close to hotspots to discover the sections",
      hintPoint: "Drag the cursor to look around · click the markers to move",
      map: "Set map",
    },
    cinema: { watch: "Watch the excerpt" },
    nodes: {
      ingresso: "Studio entrance",
      gru: "Crane & camera",
      cowboy: "The western set",
      village: "Video village",
      costumi: "Wardrobe",
      fotografo: "Set photographer",
      stunt: "Stunt area",
      bacheca: "Press board",
      corridoio: "Production corridor",
      cinema: "Cinema hall",
    },
    hotspots: {
      equipment: "Equipment rental",
      actors: "Actor filmography",
      director: "Director",
      costumes: "Costume rental",
      gallery: "Gallery",
      stunt: "Stunts",
      production: "Production",
      about: "About me",
      cinema: "Organize your screening",
      contacts: "Contact",
    },
    marquee: "ACTORDIRECTORSTUNTPERFORMER",
    films: {
      title: "Filmography",
      sub: "Every credit of Davide Campagna's career, straight from IMDb.",
      roleAll: "All roles",
      attore: "Actor",
      regista: "Director",
      doppiatore: "Voice",
      stunt: "Stunts",
      sceneggiatore: "Writer",
      formatAll: "All formats",
      feature: "Features",
      short: "Shorts",
      tv: "Series & Video",
      details: "Film details",
      role: "Role",
      year: "Year",
      imdbLink: "Open on IMDb",
      empty: "No titles match these filters.",
      rating: "IMDb rating",
    },
    rental: {
      titleEquip: "Equipment rental",
      titleCost: "Costume rental",
      subEquip: "Cinema-grade cameras, lenses, grip and lighting, ready for your set.",
      subCost: "",
      perDay: "/day",
      costumesText: "We hold a large stock of costumes and props of every kind, all available for rental. Fill in the form and let us know what you need — we are pretty sure we have it!",
      proGear: "We also have professional cinema cameras and lenses available. Fill in the form on the contacts page to find out more.",
      deposit: "Depending on the equipment selected, a proportionate deposit will be required and refunded at the end of the rental period. On request we can also arrange the rental of stage costumes and set design.",
      cats: { camere: "Cameras", ottiche: "Lenses", grip: "Grip & Movement", video: "Monitors & Video", luci: "Lighting & Panels", audio: "Sound", energia: "Power", set: "FX & Set" },
      allCats: "All",
    },
    quote: {
      title: "Your quote",
      empty: "No items yet. Add equipment or costumes from the catalog.",
      name: "Full name",
      email: "Email",
      company: "Production / Company",
      from: "From",
      to: "To",
      notes: "Notes",
      submit: "Send quote request",
      success: "Request sent! We'll reply within 24 hours.",
    },
    request: {
      kicker: "QUOTE REQUEST",
      detail: "What do you need?",
      placeholder: "List the equipment, costumes or props you need, the dates and the type of production.",
      submit: "Send request",
    },
    stunt: {
      title: "Stunts & Physical performance",
      sub: "From Verona's International Circus Academy to international sets: the body as a narrative tool.",
      skills: ["High falls", "Full body burn", "Tightrope & wirework", "Stage combat", "Acrobatics", "Circus"],
      certs: "Training: 6 years at Verona International Circus Academy (graduated 2013) · 9 years of classical dance · Italy's Got Talent 2012 · Performance for Pope Benedict XVI",
      credits: "Selected stunt credits",
    },
    gallery: {
      title: "Gallery",
      sub: "Set, backstage and action: the camera from the other side.",
      empty: "The gallery is being prepared. Official photographs will be published shortly.",
    },
    productions: {
      title: "Production",
      sub: "From development to distribution, with the production company The Palma Movie.",
      partner: "For several years Davide Campagna has been working with the production company The Palma Movie. To discover all the productions visit www.thepalmamovie.com",
      visit: "Visit thepalmamovie.com",
      pitch: "Together with The Palma Movie we can evaluate your project and give you a tailored quote to create your film from A to Z. We make the film and leave you all the rights: from concept, writing, pre-production, production, post-production, theatrical and platform distribution, to advertising.",
      titles: "Films and series produced",
      titlesSub: "A selection of The Palma Movie productions. Click to open the page on their website.",
      openSheet: "Open the page",
    },
    about: {
      title: "About me",
      sub: "From the circus to cinema: the story of Davide Campagna.",
      press: "Press",
      pressSub: "Articles and interviews about Davide Campagna.",
      readArticle: "Read the article",
      facts: ["BORN · 11.10.1996 · SCAFATI (SA), ITALY", "BASED IN SOUTH TYROL", "CIRCUS ARTS ACADEMY · VERONA · 2013", "CIRKO VERTIGO · TURIN", "STUDIO EMME ACADEMY · FILM ACTING"],
    },
    screening: {
      title: "Organize your screening",
      sub: "Bring a Davide Campagna film to your cinema, festival or cultural club.",
      trailerCta: "Watch the trailer of",
      cinemaNote: "Would you like to screen one of our films? Get in touch at",
    },
    contact: {
      name: "Full name",
      email: "Email",
      message: "Message",
      attach: "Attachment (optional)",
      attachCta: "Attach a file",
      attachHint: "PDF or image · max 8 MB",
      submit: "Send message",
      sendingLabel: "Sending...",
      success: "Message sent! I will get back to you shortly.",
      error: "Sending failed, please try again.",
      tooBig: "File too large: 8 MB maximum.",
    },
    footer: {
      tagline: "Actor · Director · Stunt Performer",
      rights: "All rights reserved.",
      nav: "Sections",
      contact: "Contact",
      contactCta: "Write to us from the Contact page →",
    },
    lang: "IT",
  },
};
